







































import { Vue, Component, Prop } from "vue-property-decorator";
import { IProvisionRequest } from "@/models/provisioning";
import {
  IProvisionRequestProviderData,
  IProvisionRequestProviderMethods
} from "@/models/providers/provisionRequests";

@Component({
  components: {
    "provision-request-provider": () =>
      import("@/components/app/admin/provisioning/provisionRequestProvider.vue")
  }
})
export default class ProvisionRequestModal extends Vue {
  // Props

  @Prop({ required: true })
  public requestId!: IProvisionRequest["id"];

  // Methods

  public getModalTitle({ request }: IProvisionRequestProviderData) {
    return this.$_.compact([
      this.$t("_.provision_request"),
      request?.function_name
    ]).join(": ");
  }

  public cancelRequest({
    openCancelRequestModal
  }: IProvisionRequestProviderMethods) {
    return openCancelRequestModal({
      onSuccess: () => this.$emit("close")
    });
  }
}
